import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { CaseStatus as _CaseStatus } from '@debbie/common/dist/cases/index.js';
import helpers from '@debbie/common/dist/economy/helpers/index.js';
import { VoucherCategory, } from '@debbie/common/dist/economy/vouchers/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import THEME from '../../theme.js';
import CaseStatus from '../CaseStatus.js';
import { ChevronDown, ExternalLink } from '../Icons/index.js';
import Money from '../Money.js';
import Table from '../Table.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
const FIRST_COLUMN_STYLE = { width: '13px', paddingRight: 0 };
const CasesOnCustomer = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", { style: {
            fontSize: '0.8em',
            cursor: 'default',
        }, onClick: (e) => {
            e.stopPropagation();
        } },
        React.createElement(Table, { zebra: true },
            React.createElement("tr", null,
                React.createElement("th", { style: FIRST_COLUMN_STYLE }),
                React.createElement("th", null, lang.customers.caseStatus),
                React.createElement("th", { style: { width: '85px', textAlign: 'right', cursor: 'pointer' }, onClick: () => c.redirect.redirect(`/cases/${props.customer.cases
                        .map((_case) => _case.id)
                        .join(',')}`) },
                    lang.customers.case,
                    " ",
                    React.createElement(ExternalLink, null)),
                React.createElement("th", { style: { textAlign: 'right' } }, lang.financials.balance)),
            props.customer.cases
                .sort((a, b) => a.id - b.id)
                .map((_case) => (React.createElement(CaseOnCustomer, { key: _case.caseId, case: _case, tenantId: props.customer.tenantId }))))));
};
export default CasesOnCustomer;
const CaseOnCustomer = (props) => {
    const { case: _case } = props;
    const lang = useSelector((s) => s.lang);
    const [detailed, setDetailed] = useState(_case.status !== _CaseStatus.ENDED);
    const caseVouchers_ = useCaseVouchersByCase(_case.caseId);
    const caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Relation, { style: { cursor: 'pointer' }, onClick: () => setDetailed(!detailed) },
            React.createElement("td", { style: FIRST_COLUMN_STYLE },
                React.createElement(ChevronDown, { style: {
                        transform: `rotate(${detailed ? '0deg' : '-90deg'})`,
                        margin: '0em 0em -0.3em 0',
                        height: '12px',
                        width: '12px',
                    } })),
            React.createElement("td", null,
                React.createElement(CaseStatus, { status: _case.status, endReasonId: _case.endReasonId, statusTime: _case.statusTime })),
            React.createElement("td", { style: { textAlign: 'right', cursor: 'pointer' }, onClick: () => c.redirect.redirect(`/cases/${_case.id}`) },
                _case.id,
                " ",
                React.createElement(ExternalLink, null)),
            React.createElement("td", { style: { textAlign: 'right' } }, caseVouchers && (React.createElement("b", null,
                React.createElement(Money, { amount: helpers.overview.balance(caseVouchers) }))))),
        detailed && caseVouchers && (React.createElement(React.Fragment, null,
            !!helpers.overview.balanceCategory(caseVouchers, VoucherCategory.PRINCIPAL) &&
                caseVouchers
                    .filter((caseVoucher) => caseVoucher.category === VoucherCategory.PRINCIPAL)
                    .map((caseVoucher) => (React.createElement(Relation, { key: caseVoucher.caseVoucherId, className: "sub-row" },
                    React.createElement("td", { style: FIRST_COLUMN_STYLE }),
                    React.createElement("td", null,
                        lang.economyVoucherTypeLabels[caseVoucher.voucherTypeId] || caseVoucher.label,
                        ' ',
                        caseVoucher.referenceId && (React.createElement("small", null, caseVoucher.referenceId))),
                    React.createElement("td", { style: { textAlign: 'right' } }, moment(caseVoucher.date).format(THEME.DATE_FORMAT_SHORT)),
                    React.createElement("td", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: caseVoucher.amount }))))),
            caseVouchers && (React.createElement(React.Fragment, null,
                React.createElement(SummedEconomyCategory, { category: VoucherCategory.COST, caseVouchers: caseVouchers }),
                React.createElement(SummedEconomyCategory, { category: VoucherCategory.INTEREST, caseVouchers: caseVouchers }),
                React.createElement(SummedEconomyCategory, { category: VoucherCategory.TRANSACTION, caseVouchers: caseVouchers })))))));
};
const Relation = styled.tr ``;
const SummedEconomyCategory = (props) => {
    const { category, caseVouchers } = props;
    const lang = useSelector((s) => s.lang);
    return helpers.overview.balanceCategory(caseVouchers, category) ? (React.createElement(Relation, { className: "sub-row" },
        React.createElement("td", { style: FIRST_COLUMN_STYLE }),
        React.createElement("td", null,
            lang.economyCategories[category],
            " (",
            caseVouchers.filter((voucher) => voucher.category === category).length,
            ")"),
        React.createElement("td", { style: { textAlign: 'right' } }),
        React.createElement("td", { style: { textAlign: 'right' } },
            React.createElement(Money, { amount: helpers.overview.balanceCategory(caseVouchers, category) })))) : null;
};
//# sourceMappingURL=CasesOnCustomer.js.map